
const apiUrl = process.env.REACT_APP_API_URL;

const getPhilippinesDate = () => {
    const options = {
        timeZone: 'Asia/Manila',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    };

    const formatter = new Intl.DateTimeFormat('en-PH', options);
    return formatter.format(new Date());
};

const generateOrderId = () => {
    const datePart = getPhilippinesDate().replaceAll('/', '');
    const randomPart = Math.floor(10000 + Math.random() * 90000);
    return `OD${datePart}${randomPart}`;
};

export const getOrderId = async () => {
    let orderId;
    let isUnique = false;

    while (!isUnique) {
        orderId = generateOrderId();

        try {
            const response = await fetch(`${apiUrl}validation/validate_order_id.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ orderId }),
            });

            const data = await response.json();
            isUnique = data.unique;
        } catch (error) {
            console.error('Error validating order number:', error);
            break;
        }
    }

    return orderId;
};
